import { IconProps, Icon } from '@bnb-chain/space';

export function TokenPocketIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <rect width="24" height="24" fill="#2980FE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 7.04167V9.34376C4 9.53936 4.15857 9.69793 4.35417 9.69793H6.47917V17.3125C6.47917 17.5081 6.63774 17.6667 6.83334 17.6667H9.13543C9.33104 17.6667 9.4896 17.5081 9.4896 17.3125V9.69793H10.4636C11.2949 9.69793 11.9688 9.02402 11.9688 8.19271C11.9688 7.36141 11.2949 6.6875 10.4636 6.6875H4.35417C4.15857 6.6875 4 6.84607 4 7.04167ZM12.1459 11.1146V17.3125C12.1459 17.5081 12.3044 17.6667 12.5 17.6667H15.1563C15.3519 17.6667 15.5105 17.5081 15.5105 17.3125V15.3646H16.6615C19.0576 15.3646 21.0001 13.4222 21.0001 11.0261C21.0001 8.62994 19.0138 6.6875 16.6177 6.6875C14.1727 6.6875 12.1459 8.66958 12.1459 11.1146ZM17.6355 11.0261C17.6355 11.564 17.1994 12 16.6615 12C16.1236 12 15.6875 11.564 15.6875 11.0261C15.6875 10.4882 16.1236 10.0521 16.6615 10.0521C17.1994 10.0521 17.6355 10.4882 17.6355 11.0261Z"
        fill="white"
      />
    </Icon>
  );
}
